// Module
var code = "<div data-bind=\"if: highchartsOptions()\">\n    <div data-bind=\"highcharts: {options: highchartsOptions, chart: chart}, event: { mousedown: mousedown }\" class=\"chart voyage\"></div>\n</div>";
// Exports
module.exports = code;